import { BatchEditAttributeName } from '../../../types/batchActions';
import { BatchAction } from '../../../types/store';

export const getAttributeParamsForBatchAction = (action: BatchAction) => {
  switch (action) {
    case BatchAction.BOOL_AI_ADD:
      return {
        attrName: BatchEditAttributeName.AI_GENERATED,
        attrValue: true,
      };
    case BatchAction.BOOL_AI_DEL:
      return {
        attrName: BatchEditAttributeName.AI_GENERATED,
        attrValue: false,
      };
    case BatchAction.BOOL_MATURE_ADD:
      return {
        attrName: BatchEditAttributeName.IS_MATURE,
        attrValue: true,
      };
    case BatchAction.BOOL_MATURE_DEL:
      return {
        attrName: BatchEditAttributeName.IS_MATURE,
        attrValue: false,
      };
    case BatchAction.BOOL_NOAI_ADD:
      return {
        attrName: BatchEditAttributeName.ALLOW_IN_AI_DATASETS,
        attrValue: false,
      };
    case BatchAction.BOOL_NOAI_DEL:
      return {
        attrName: BatchEditAttributeName.ALLOW_IN_AI_DATASETS,
        attrValue: true,
      };

    default:
      return {};
  }
};
